export default __webpack_public_path__ + "static/media/beard-trim.cb038fe6.gif";